<template>
  <div>
    <div v-if="pick.type === 'Parlay'" class="columns">
      <div :class="`column ${columnClasses}`">
        <div class="has-text-right"><span class="tag is-primary is-light is-small">Parlay</span></div>
      </div>
    </div>
    <div class="columns is-vcentered is-mobile">
      <div :class="`column ${columnClasses}`">

        <div v-if="pick.type !== 'Parlay'">

          <div v-if="shouldObscureMatchUp" class="has-text-centered">
            <p class="title is-4">
              {{pick.type}} Bet
            </p>
          </div>

          <matchup v-else
                   :away-team="pick.awayTeam"
                   :home-team="pick.homeTeam"
                   :units="units" />

        </div>

        <div v-else>
          <div v-for="(bet, i) in pick.bets" :key="bet.id" :class="`${i !== pick.bets.length - 1 ? 'mb-6' : ''}`">

            <div v-if="shouldObscureMatchUp" class="has-text-centered">
              <p class="title is-4">
                {{bet.type}} Bet
              </p>
            </div>

            <matchup v-else
                     :away-team="bet.awayTeam"
                     :home-team="bet.homeTeam" />

          </div>
        </div>

      </div>

      <div class="column is-hidden-mobile has-text-centered">
        <p v-if="pick.isBiggest">
          <span class="tag is-success"><b-icon icon="seal" />&nbsp;<span>Biggest {{ pickLabel }}</span></span>
        </p>
        <p v-if="units" class="title is-4">
          {{units}} Unit{{units > 1 ? 's' : ''}}
        </p>
      </div>

      <div class="column has-text-right">
        <p v-if="pick.isBiggest" class="is-hidden-tablet">
          <span class="tag is-success is-small"><b-icon icon="seal" />&nbsp;<span>Biggest {{ pickLabel }}</span></span>
        </p>
        <p class="heading is-size-6">
          {{ date }}
          <span class="no-wrap">{{time}}</span>
        </p>
        <div v-if="!isClosed">
          <CountDown @eventStarted="isClosed = true" :date-time="pick.dateTime" />
        </div>
        <p v-else><span class="tag is-medium is-light is-primary is-hidden-mobile">Closed</span></p>
      </div>
    </div>

    <div v-if="youTubeVid" class="columns mt-3">
      <div class="column is-6">
        <h5 class="title is-5 has-text-centered">Previous Matchup</h5>
        <you-tube :vid-id="youTubeVid" />
      </div>
    </div>
  </div>
</template>

<script>
import CountDown from '@/components/members/CountDown';
import Matchup from '@/components/misc/Matchup';
import YouTube from '@/components/misc/YouTube';

export default {
  components: {
    CountDown,
    Matchup,
    YouTube
  },
  props: {
    pick: Object,
    columnClasses: String,
    shouldObscureMatchUp: Boolean,
  },
  data() {
    return {
      isClosed: false,
      pickLabel: process.env.VUE_APP_PICK_LABEL || 'Pick'
    }
  },
  computed: {
    date: function () {
      return new Date(this.pick.dateTime).toLocaleDateString();
    },
    time: function () {
      return new Date(this.pick.dateTime).toLocaleTimeString('en-us', {hour: '2-digit', minute: '2-digit'});
    },
    units: function () {
      let { risk, gain } = this.pick;
      return risk < gain ? risk : gain;
    },
    youTubeVid: function () {
      if (!('instructions' in this.pick)) {
        return '';
      }

      let cleanInstructions = this.pick.instructions.replace(/(N\/A)/g, '');

      let params = new URLSearchParams(cleanInstructions);

      if (params.has('youTubeVid')) {
        return params.get('youTubeVid');
      }

      return '';
    }
  }
}
</script>